import React, { forwardRef } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { XCircle } from '@olxbr/ds-icons';
import { Check } from '@olxbr/ds-icons';
import { Info } from '@olxbr/ds-icons';
import { AlertTriangle } from '@olxbr/ds-icons';
import { Text } from '../Text';
import * as Styles from './styles';
const Icon = _ref => {
  let {
    variant
  } = _ref;
  const variants = {
    default: Info,
    error: XCircle,
    success: Check,
    warning: AlertTriangle,
    information: Info
  };
  const Icon = variants[variant];
  return React.createElement(Icon, null);
};
export const Alertbox = forwardRef((_ref2, ref) => {
  let {
    variant = 'default',
    role,
    icon,
    title,
    children,
    time = ''
  } = _ref2;
  return React.createElement(Styles.AlertboxWrapper, {
    "data-ds-componet": "DS-Alertbox",
    ref: ref,
    className: variant,
    variant: variant,
    role: !role && variant === 'error' ? 'alert' : role || 'status',
    title: title
  }, React.createElement(Styles.ContentWrapper, {
    style: {
      display: 'flex'
    }
  }, React.createElement(Styles.IconWrapper, {
    "aria-hidden": "true"
  }, icon || React.createElement(Icon, {
    variant: variant
  })), React.createElement(Styles.AlertboxContent, null, React.createElement(Styles.AlertboxTitle, {
    variant: variant,
    title: title
  }, title), React.createElement(Styles.AlertboxDescription, null, children))), !!time && React.createElement(Styles.TimeWrapper, null, React.createElement(Text.Caption, {
    tag: "p"
  }, time)));
});
Alertbox.displayName = 'Alertbox';